export enum LiliLinkType {
  DEFAULT = 'DEFAULT',
  QUIET = 'QUIET',
  SMART = 'SMART',
  SECONDARY = 'SECONDARY',
  SECONDARY_QUITE = 'SECONDARY_QUITE',
}

export enum LiliLinkSize {
  SMALL = 'SMALL',
  MEDIUM = 'MEDIUM',
}

// Base props shared between components
export interface BaseLiliLinkProps {
  type?: LiliLinkType;
  size?: LiliLinkSize;
  title: string;
  id: string;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  className?: string;
  testId?: string;
}

export interface LiliLinkProps extends BaseLiliLinkProps {
  href: string;
  target?: HTMLAnchorElement['target'];
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
}

export interface LiliLinkButtonProps extends BaseLiliLinkProps {
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  buttonType?: HTMLButtonElement['type'];
}
